<template>
    <full-overlay ref="overlay" @click="overlayClicked" :style="overlayStyle">
        <transition-group name="bounce">
            <div v-if="show" class="ding-modal-wrapper" key="modal-content" :style="{width: computedWidth, maxWidth: computedMaxWidth}" ref="modal-content">
                <div class="ding-modal-white-background"></div>
                <div v-if="!noTitleBar" class="ding-modal-title-bar">
                    <slot name="title"></slot>
                    <span v-if="showModalCloseButton" cy-modal-close class="ding-modal-close-button" @click="close()"></span>
                </div>
                <div class="ding-modal-content need-webkit-scroller-fix" :style="modalContentStyle">
                    <slot></slot>
                </div>
                <div class="ding-modal-footer-bar modal-footer-">
                    <slot name="footer"></slot>
                </div>
            </div>
        </transition-group>
    </full-overlay>
</template>

<script>
import fullOverlay from './FullOverlay';
export default {
    components: {fullOverlay},
    props: {
        width: String,
        maxWidth: String,
        noTitleBar: {
            type: Boolean,
            default: false
        },
        contentOverflow: {
            type: String,
            default: 'auto'
        },
        escClosing: {
            type: Boolean,
            default: false
        },
        clickBackdropClosing: {
            type: Boolean,
            default: false
        },
        showModalCloseButton: {
            type: Boolean,
            default: true
        },
        forceHeight: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            show: false,
            overlayStyle: {}
        }
    },
    mounted() {
        window.addEventListener('keyup', this.handleKeyup);
        $('body, .page-content').addClass('modal-open');
        $('body, .page-content').removeClass('need-webkit-scroller-fix');
        this.show = true;

        const fullOverlay = this.$refs['overlay'];
        if (fullOverlay) {
            const $containerSwiper = $(fullOverlay.$el).parents('.swiper-wrapper');
            const $modals = $(fullOverlay.$el).parents('.ding-modal-wrapper');
            if ($containerSwiper.length > 0 && $modals.length === 1) {
                const transformX = (new DOMMatrix($containerSwiper[0].style.transform)).e
                this.overlayStyle.transform = `translateX(${-transformX}px`;
            }
        }

        if (this.isIOS) {
            // To fix iOS nested position:fixed being clipped by parent which is also position:fixed and overflow: auto
            $(this.$el).parents('.ding-modal-content').css({overflow: 'unset'});
        }
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeyup);
        $('body, .page-content').removeClass('modal-open');
        $('body, .page-content').addClass('need-webkit-scroller-fix');
        if (this.isIOS) {
            $('.ding-modal-content').css({overflow: 'auto'});
        }
    },
    computed: {
        computedWidth() {
            return this.width || '75%';
        },
        computedMaxWidth() {
            return this.maxWidth || '720px';
        },
        isIOS() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent);
        },
        modalContentStyle() {
            let style = {
                overflow: this.contentOverflow
            }
            if (this.forceHeight) {
                // style.height = `calc(${this.forceHeight} - 64px) !important`;
                style.maxHeight = `calc(${this.forceHeight} - 64px) !important`;
            }
            return style;
        }
    },
    methods: {
        overlayClicked() {
            if (this.clickBackdropClosing && this.showModalCloseButton) {
                this.close();
            }
        },
        handleKeyup(event) {
            // NOOP when if there's any childeren `.ding-modal-wrapper`
            // let top most modal to handle this event
            // Should be more than 1 children because the first one is current modal's wrapper
            if ($(this.$el).find('.ding-modal-wrapper, .ding-popup-wrapper').length > 1) {
                return;
            }

            switch (event.keyCode) {
                case 27:
                    if(this.escClosing) {
                        this.close();
                    }
                    break;
            }
            event.preventDefault();
            event.stopPropagation();
        },
        close() {
            this.show = false;
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" >

.ding-modal-wrapper {
    width: 75%;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
}

.ding-modal-content {
    max-height: calc(70vh - 64px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}

.ding-modal-title-bar {
    display: flex;
    flex-direction: row;
    background: #E8E8E8;
    color: #90A4AE;
    font-size: 14px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    align-items: center;
}

.ding-modal-title-bar > * {
    flex-grow: 1;
    font-size: 14px;
    padding: 10px 15px 10px 25px;
    margin-right: -10px;
}

.ding-modal-white-background {
    background: white;
    overflow: hidden;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.ding-modal-close-button {
    flex-grow: 0;
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url('/img/close_cross@2x.png');
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    right: 10px;
    border-radius: 4px;
    cursor: pointer;
}

.ding-modal-close-button:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

.ding-modal-footer-bar {
    background: white;
    border-top: 1px solid #EEE;
    box-shadow: 0px 4px 8px #DDD;
}

</style>
